import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Api, Ui, Session, ErrorHelper } from '../services/index';


@Component({
	selector: 'forgot-password',
	templateUrl: 'forgot-password.html'
})
export class ForgotPassword {
  emailAddress: string;
  emailFormGroup: FormGroup;
	submitted: boolean;

	constructor(private api: Api,
              private errorHelper: ErrorHelper,
              private fb: FormBuilder,
              private router: Router,
              private service: NotificationsService,
              private session: Session,
              private ui: Ui) {
      this.emailFormGroup = this.fb.group({
        'email': new FormControl(this.emailAddress, [this.emailOrEmpty, Validators.required])
      })
	 }
   
   emailOrEmpty(control: AbstractControl): ValidationErrors {
     if (!control.value) {
       return null;
     }
   
     return Validators.email(control);
   }

   get email() { return this.emailFormGroup.get('email'); }

  requesting(requesting: boolean){
    this.ui.showLoadingIndicator(requesting);
    this.submitted = requesting;
  }

	submitTapped() {
    this.requesting(false);
    if(this.session.selectedLang === 'en'){
      this.api.forgotPassword(this.emailAddress).subscribe(result => {
        if (result.emailSent) {
          this.service.success('An email has been sent with instructions to reset your password.');
          this.router.navigate(['/login' ]);
        } else {
          this.service.error('Email not found');
          this.emailFormGroup.controls['email'].setErrors({'server':'Email not found' })
        }
        this.requesting(false);
      }, (ex) => {
        this.errorHelper.handleServerValidation(this.emailFormGroup, ex);
        this.requesting(false);
      });
    }else if(this.session.selectedLang === 'es'){
      this.api.forgotPasswordES(this.emailAddress).subscribe(result => {
        if (result.emailSent) {
          this.service.success('Se ha enviado un correo electrónico con instrucciones para restablecer su contraseña.');
          this.router.navigate(['/login' ]);
        } else {
          this.service.error('El correo electrónico no encontrado');
          this.emailFormGroup.controls['email'].setErrors({'server':'El correo electrónico no encontrado' })
        }
        this.requesting(false);
      }, (ex) => {
        this.errorHelper.handleServerValidation(this.emailFormGroup, ex);
        this.requesting(false);
      });
    }else{
      this.api.forgotPassword(this.emailAddress).subscribe(result => {
        if (result.emailSent) {
          this.service.success('An email has been sent with instructions to reset your password.');
          this.router.navigate(['/login' ]);
        } else {
          this.service.error('Email not found');
          this.emailFormGroup.controls['email'].setErrors({'server':'Email not found' })
        }
        this.requesting(false);
      }, (ex) => {
        this.errorHelper.handleServerValidation(this.emailFormGroup, ex);
        this.requesting(false);
      });
    }

	}
}